module.exports = __webpack_public_path__ + "static/media/alchemist.8c460cef.gif";